import React from 'react';
import { ErrorMessage } from 'formik';

import BasicInput from 'components/BasicInput';

const FormStep4 = ({
  values,
  errors,
  touched,
  dirty,
  handleChange,
  handleBlur,
  params: { isRecruiter },
}) => {
  return (
    <div className="form__step">
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <BasicInput
          label="Work Email"
          name="workEmail"
          inputType="email"
          content={values.workEmail}
          placeholder="Type here..."
          controlFunc={handleChange}
          isValid={
            (!errors.workEmail && !!touched.workEmail) || !touched.workEmail
          }
          touchFunc={handleBlur}
          labelStyles={{ fontWeight: 'bold' }}
        />

        <ErrorMessage
          name="workEmail"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '15px' }}>
        <BasicInput
          label="Alternative Email (optional)"
          required={false}
          name="email2"
          inputType="email"
          content={values.email2}
          placeholder="Type here..."
          controlFunc={handleChange}
          isValid={(!errors.email2 && !!touched.email2) || !touched.email2}
          touchFunc={handleBlur}
          labelStyles={{ fontWeight: 'bold' }}
        />

        <ErrorMessage
          name="email2"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '15px' }}>
        <BasicInput
          label="Phone Number for Contact"
          required={true}
          name="phone"
          inputType="tel"
          content={values.phone}
          placeholder="Type here..."
          controlFunc={handleChange}
          isValid={(!errors.phone && !!touched.phone) || !touched.phone}
          touchFunc={handleBlur}
          labelStyles={{ fontWeight: 'bold' }}
        />

        <ErrorMessage
          name="phone"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '30px' }}>
        <BasicInput
          label="Second Number (optional)"
          required={false}
          name="phone2"
          inputType="tel"
          content={values.phone2}
          placeholder="Type here..."
          controlFunc={handleChange}
          isValid={(!errors.phone2 && !!touched.phone2) || !touched.phone2}
          touchFunc={handleBlur}
          labelStyles={{ fontWeight: 'bold' }}
        />

        <ErrorMessage
          name="phone2"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
    </div>
  );
};

export default FormStep4;
